import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import PreviewPropertyContext from './PreviewPropertyContext';

const PreviewPropertyProvider = React.memo(({ children }) => {
  const [previewProperty, setPreviewProperty] = useState();

  const value = useMemo(
    () => ({
      previewProperty,
      setPreviewProperty,
    }),
    [previewProperty],
  );

  return (
    <PreviewPropertyContext.Provider value={value}>
      {children}
    </PreviewPropertyContext.Provider>
  );
});

PreviewPropertyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PreviewPropertyProvider;
